module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAANCAYAAABcrsXuAAAABHNCSVQICAgIfAhkiAAAAHZJREFUOI21zbENgDAMRNFv9ggFBT0lEkXYgC1gJMZJxyDsgamRoigGc+WXTk8I8eBMI38sxAWVHgBpZ3UH2rgS4v5orlAOcIVKgAtUA3yCLMAr6A1ggr4AVZAHUIQ8gSxkBMQKKbqhDJxpq/01FkRh4pLOAgDcLVIvOQPqzfwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/jumbotronArrow.png
// module id = +gGC
// module chunks = 1